import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setcheckedCategory } from '../redux/features/projects/projectFilterSlice';

const Project = ({project}) => {
  const {checkedCategory,searchKey}=useSelector(state=>state.filterProjects);
 


    const {projectName,colorClass,id} =project || {};
    const dispatch= useDispatch()
  return (
    <div className="checkbox-container">
    <input type="checkbox" onChange={()=> dispatch(setcheckedCategory(checkedCategory?.includes(id) ?     checkedCategory.filter(p=>p!==id) :[...checkedCategory,id]))} checked={checkedCategory?.includes(id)} className={`${colorClass}`}  />
    <p className="label">{projectName}</p>
  </div>
  )
}

export default Project